import React from 'react';
import { useDashboard } from '../hooks/useDashboard';
import { useScanHistory } from '../hooks/useScanHistory';
import { useImageProcessing } from '../hooks/useImageProcessing';
import DashboardLayout from './DashboardLayout';

const Dashboard = () => {
  // Main dashboard logic
  const dashboardState = useDashboard();
  
  // Scan history management
  const scanHistoryState = useScanHistory();
  
  // Image processing capabilities
  const imageState = useImageProcessing(
    dashboardState.selectedDate,
    dashboardState.setMacroResult,
    dashboardState.setError
  );

  return (
    <DashboardLayout      // Alert props
      scanLoading={dashboardState.scanLoading}
      scanError={dashboardState.scanError}
      loading={dashboardState.loading}
      imageLoading={imageState.imageLoading}
      error={dashboardState.error}        // Modal props
      showBarcodeModal={dashboardState.showBarcodeModal}
      setShowBarcodeModal={dashboardState.setShowBarcodeModal}
      handleBarcodeDetected={dashboardState.handleBarcodeDetected}
      scannedProductData={dashboardState.scannedProductData}
      showScannedProduct={dashboardState.showScannedProduct}
      onConfirmProduct={dashboardState.handleConfirmScannedProduct}
      onRetryScanning={dashboardState.handleRetryBarcodeScan}
      showScanHistory={scanHistoryState.showScanHistory}
      setShowScanHistory={scanHistoryState.setShowScanHistory}
      scanHistory={scanHistoryState.scanHistory}
      showCameraModal={imageState.showCameraModal}
      setShowCameraModal={imageState.setShowCameraModal}
      cameraResOptions={imageState.cameraResOptions}
      cameraResolution={imageState.cameraResolution}
      setCameraResolution={imageState.setCameraResolution}
      webcamRef={imageState.webcamRef}
      handleCapture={imageState.handleCapture}
      showGalleryModal={imageState.showGalleryModal}
      setShowGalleryModal={imageState.setShowGalleryModal}
      getRootProps={imageState.getRootProps}
      getInputProps={imageState.getInputProps}
      isDragActive={imageState.isDragActive}
      
      // Header props
      selectedDate={dashboardState.selectedDate}
      setSelectedDate={dashboardState.setSelectedDate}
      getMacroSummary={dashboardState.getMacroSummary}
      getTargets={dashboardState.getTargets}
      
      // Content props
      foodLog={dashboardState.foodLog}
      editMealId={dashboardState.editMealId}
      editMealData={dashboardState.editMealData}
      handleEdit={dashboardState.handleEdit}
      handleEditChange={dashboardState.handleEditChange}
      handleEditSave={dashboardState.handleEditSave}
      handleEditCancel={dashboardState.handleEditCancel}
      handleDelete={dashboardState.handleDelete}
      handleMacroEdit={dashboardState.handleMacroEdit}
      
      // Input bar props
      prompt={dashboardState.prompt}
      setPrompt={dashboardState.setPrompt}
      handlePromptSubmit={dashboardState.handlePromptSubmit}
      handleGallery={imageState.handleGallery}
      handleCamera={imageState.handleCamera}
      fileInputRef={imageState.fileInputRef}
      handleImageUpload={imageState.handleImageUpload}
      
      // Manual entry props
      manualEntry={dashboardState.manualEntry}
      handleManualSubmit={dashboardState.handleManualSubmit}
    />
  );
};

export default Dashboard;
